export class PatientHealthTasks {
  id?: number;
  healthTasksId?: number;
  patientId?: number;
  quantity?: number;
}
